<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">
        {{ isEditing ? 'Editar Objeto' : 'Nuevo Objeto' }}
      </h5>
      <button type="button" class="btn-close" @click="$emit('cancel')"></button>
    </div>
    
    <form @submit.prevent="handleSubmit">
      <div class="modal-body">
        <div class="row">
          <div class="col-md-6">
            <FormField
              v-model="formData.ObjetoId"
              :field="formFields[0]"
              :disabled="isEditing"
            />
          </div>
          <div class="col-md-6">
            <FormField
              v-model="formData.Nombre"
              :field="formFields[1]"
            />
          </div>
        </div>
        
        <div class="row">
          <div class="col-md-12">
            <FormField
              v-model="formData.TablaEspecifica"
              :field="formFields[2]"
            />
          </div>
        </div>
      </div>
      
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="$emit('cancel')">
          Cancelar
        </button>
        <button type="submit" class="btn btn-primary" :disabled="loading">
          <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
          {{ isEditing ? 'Actualizar' : 'Guardar' }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import FormField from '@/shared/components/FormField.vue';

export default {
  name: 'CatObjetoForm',
  components: {
    FormField
  },
  props: {
    objeto: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['submit', 'cancel'],
  data() {
    return {
      formData: {
        ObjetoId: 0,
        Nombre: '',
        TablaEspecifica: ''
      },
      formFields: [
        {
          key: 'ObjetoId',
          label: 'ID del Objeto',
          type: 'number',
          required: true,
          placeholder: 'Ingrese el ID del objeto'
        },
        {
          key: 'Nombre',
          label: 'Nombre',
          type: 'text',
          required: true,
          placeholder: 'Ingrese el nombre del objeto'
        },
        {
          key: 'TablaEspecifica',
          label: 'Tabla Específica',
          type: 'text',
          required: false,
          placeholder: 'Ingrese la tabla específica'
        }
      ]
    };
  },
  watch: {
    objeto: {
      handler(newVal) {
        if (newVal) {
          this.formData = {
            ObjetoId: newVal.ObjetoId || 0,
            Nombre: newVal.Nombre || '',
            TablaEspecifica: newVal.TablaEspecifica || ''
          };
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleSubmit() {
      if (this.validateForm()) {
        this.$emit('submit', { ...this.formData });
      }
    },
    validateForm() {
      if (!this.formData.ObjetoId || this.formData.ObjetoId <= 0) {
        this.$toast.error('El ID del objeto es requerido y debe ser mayor que cero');
        return false;
      }
      
      if (!this.formData.Nombre || this.formData.Nombre.trim() === '') {
        this.$toast.error('El nombre es requerido');
        return false;
      }
      
      return true;
    }
  }
};
</script>

<style scoped>
.modal-content {
  border-radius: 0.5rem;
}

.modal-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.modal-footer {
  background-color: #f8f9fa;
  border-top: 1px solid #dee2e6;
}

.btn-primary {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.btn-primary:hover {
  background-color: #0b5ed7;
  border-color: #0a58ca;
}
</style>
